import React, { FC } from 'react'
import FavoriteConnector, { ConnectorProps as FavoriteProps } from 'containers/SessionFavorites'
import useFavorite from './hook'
import { FavoriteActionItem, HeartIcon, ActionItem } from '../styles'
import useSearchProvider from 'components/SA/SearchProvider/hooks/useSearchProvider'

type Props = FavoriteProps & {
  artworkId: number
  onSuccess: (...args: Array<any>) => any
  isOverlayIcon: boolean
}

const FavoriteIcon: FC<Props> = (props) => {
  // action, clickFavorite, isFavorite, blockEvents
  const { formAction, onClickFavorite, isFavorite, shouldBlockEvents } = useFavorite(props)
  const { getSearchProviderAttributes } = useSearchProvider()
  const ContainerComponent = props.isOverlayIcon ? ActionItem : FavoriteActionItem

  return (
    <ContainerComponent
      {...(shouldBlockEvents
        ? {
            'data-blocked': true,
          }
        : {})}
      data-action={formAction}
      data-type='action'
      href='#favorite'
      title={isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
      onClick={onClickFavorite}
      {...getSearchProviderAttributes([{ 'button-action': 'like' }])}
    >
      <HeartIcon
        {...(isFavorite
          ? {
              'data-favorite': 'favorite',
            }
          : {})}
      />
    </ContainerComponent>
  )
}

export default FavoriteConnector(FavoriteIcon)
